import React from "react";
import { isLogin } from "../constant/helper";
import { Redirect, Route } from "react-router-dom";

const isAuthenticated = isLogin();
const PrivateRoute = ({ component: Component, ...props }) => {
  return (
    <Route
      {...props}
      render={() =>
        isAuthenticated ? (
          <Component {...props} auth={isAuthenticated} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              search: `continue=${encodeURI(
                window.location.href.replace(window.location.origin, "")
              )}`,
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
